const taskTemplates = require('../../task-templates');

const tasksData = [
	/* Case 1 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'logic-input-answer-count-squares',
		text: `Gymnasieelever synes ofte, det er sjovt med logisk tænkning. Tjek figuren – hvor mange kvadrater kan I finde?`,
		hintText: `Det hjælper at tælle systematisk.`,
		popupText: `Når man tæller kvadrater systematisk, opdager man hurtigt de skjulte mindre kvadrater inde i de større. Og der er 34.`,
		answer: 34,
		unit: 'kvadrater',
		image: 'it-squares'
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'logic-input-answer-rebus',
		subtype: 'string',
		text: `Kan I knække rebussen? Se på billederne og skriv ordet.`,
		hintText: `I kan sige det højt, så giver det ofte mening.`,
		answer: 'Klasselokale',
		unit: null,
		image: 'rebus'
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		subtype: 'images',
		title: 'Opgave 3',
		taskId: 'fields-mc-iq-test',
		text: `Der mangler en brik i mønsteret – kan I regne ud, hvilken der skal være der?`,
		hintText: `Der er vist noget med, at formen skifter hver gang på tre forskellige pladser i figuren.`,
		layout: 'iq-test',
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 'a', isCorrect: true}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 'b'}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 'c'}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 'd'}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 'e'}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 'f'})
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		title: 'Opgave 4',
		taskId: 'logic-input-answer-math',
		text: `Tid til lidt gymnasiel hjernegymnastik: Hvis 2 malere kan male 2 værelser på 2 timer, hvor mange malere skal I så bruge for at male 18 værelser på 6 timer? Skriv tallet I mener er det rigtige.`,
		hintText: `Nogle af påstandene er lidt overdrevne.`,
		popupText: `Én maler når 3 værelser på 6 timer. For at nå 18 værelser på samme tid skal vi bruge 6 malere.`,
		answer: 6,
		unit: 'malere',
		image: 'painter'
	}),
	/* Case 2 */
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		taskId: 'logic-sort-myths',
		title: 'Opgave 1',
		text: `Der findes mange påstande om gymnasiet – men hvad er virkelighed, og hvad er bare en myte? Sortér tingene i de rigtige kategorier.`,
		hintText: `Prøv at matche ikonerne med et fagområde.`,
		layout: 'logic-myths',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'myth', title: `Myte`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'real', title: `Virkelighed`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Kun de klogeste, der kommer på gymnasiet`, categoryIds: ['myth']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Eleverne kan frit vælge alle sine fag selv`, categoryIds: ['myth']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Gymnasiet er kun for dem, der vil på universitetet`, categoryIds: ['myth']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Studieture er altid til udlandet`, categoryIds: ['myth']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Alle gymnasieelever får en studenterhue, hvis de gennemfører`, categoryIds: ['real']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Gymnasielivet handler lige så meget om fællesskab som om fag`, categoryIds: ['real']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Alle lærere holder øje med, om man deltager aktivt i timerne`, categoryIds: ['real']})
		]
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'logic-spot-errors-classroom',
		layout: 'logic-classroom',
		text: `I dette klasselokale har der sneget sig nogle ting ind, som bestemt ikke hører til. Kan I finde fejlene? Klik OK når I mener I har dem alle.`,
		hintText: `Kig efter ting, man aldrig ser i et klasselokale.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'vape'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'beer'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'ashtray'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'animal'})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		taskId: 'logic-order-cities',
		title: 'Opgave 3',
		text: `I denne opgave skal I teste jeres geografiske overblik. Kan I sætte de fem danske byer i rækkefølge fra nord til syd?`,
		hintText: `Tjek et Danmarkskort.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Aalborg`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Århus`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `København`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Esbjerg `, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Odense`, correctOrderNumbers: [5]
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		taskId: 'logic-order-planets',
		title: 'Opgave 4',
		text: `I astronomi lærer man bl.a. om vores solsystem. Kan I sætte planeterne i den rigtige rækkefølge fra solen og udad?`,
		hintText: `Det er lige til at slå op på nettet.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Merkur`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Venus`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Jorden`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Mars `, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Jupiter`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Saturn`, correctOrderNumbers: [6]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 7, text: `Uranus`, correctOrderNumbers: [7]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 8, text: `Neptun`, correctOrderNumbers: [8]
			})
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 5,
		title: 'Opgave 5',
		taskId: 'logic-input-answer-stx-color',
		text: `Når man bliver student fra HF, får man huen på. Hvilken farve har den?`,
		hintText: `Alle gymnasielle uddannelser har forskellige farver.`,
		popupText: `Alle gymnasier bruger farver som identitet, derfor har hver uddannelse sin egen huefarve.`,
		answer: 'Blå',
		altAnswers: ['mørkeblå'],
		subtype: 'string',
		unit: null,
		image: 'hat-colors'
	}),
	/* Case 3 */
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		taskId: 'logic-sort-elements',
		title: 'Opgave 1',
		text: `I kemi lærer man om det periodiske system, hvor grundstofferne er delt ind i grupper alt efter deres egenskaber. Nogle er ædelgasser, andre er alkalimetaller, og nogle er halogener.
			<br />Sorter stofferne i de rigtige kategorier.`,
		hintText: `Brug det periodiske system, ChatGPT eller Google som hjælp.`,
		popupText: `Det periodiske system er en slags oversigt over alle grundstofferne i verden. Det bliver brugt i både kemiundervisning og forskning.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'noble', title: `Ædelgasser`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'alkali', title: `Alkalimetaller`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'halo', title: `Halogener`}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Helium`, categoryIds: ['noble']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Radon`, categoryIds: ['noble']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Natrium`, categoryIds: ['alkali']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Kalium`, categoryIds: ['alkali']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Flour`, categoryIds: ['halo']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Jod`, categoryIds: ['halo']})
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'logic-input-answer-area-math',
		text: `I matematik arbejder man tit med arealer og geometri. Forestil jer, at klasselokalet er et stort rektangel: 3 meter på den ene led og 4 meter på den anden. Hvor stort er arealet af rummet i m²?`,
		hintText: `Det står i alle grundbøger i matematik og hedder "Arealet af en firkant".`,
		popupText: `Det rigtige svar er 12 m² – og formlen hedder bare længde × bredde. Faktisk noget I allerede har lært i skolen.`,
		answer: 12,
		unit: 'm²',
		image: 'empty-classroom'
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		taskId: 'logic-sort-country-items',
		subtype: 'images',
		title: 'Opgave 3',
		text: `I gymnasiet kan man vælge mange forskellige sprog – både dem, I kender i forvejen, og nogle helt nye. Her får I fire sprog. Træk billederne over til det rigtige flag.`,
		hintText: `Overvej, hvad man forbinder med kultur og mad.`,
		layout: 'country-items',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'spain', type: 'image'}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'france', type: 'image'}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'uk', type: 'image'}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'china', type: 'image'}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'flamenco', type: 'image', categoryIds: ['spain']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'paella', type: 'image', categoryIds: ['spain']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'eiffel', type: 'image', categoryIds: ['france']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'croissant', type: 'image', categoryIds: ['france']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'big-ben', type: 'image', categoryIds: ['uk']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'london-bus', type: 'image', categoryIds: ['uk']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'wall', type: 'image', categoryIds: ['china']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'rice', type: 'image', categoryIds: ['china']}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 4,
		taskId: 'logic-order-government',
		title: 'Opgave 4',
		text: `I samfundsfag lærer man bl.a. om magtens tredeling i Danmark. Kan I sætte de tre magter i den rigtige rækkefølge, som grundloven nævner dem?`,
		hintText: `Det kan findes online under “magtens tredeling i Danmark”.`,
		popupText: `Folketinget er den lovgivende, Regeringen er den udøvende og domstolene er den dømmende.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Lovgivende`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Udøvende`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Dømmende `, correctOrderNumbers: [3]
			})
		]
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'stxhf-logic-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};